module.exports = __webpack_public_path__ + "img/05-title.03f3e3b2.png";